module.exports = __webpack_public_path__ + "img/Weapon_95.ef7476c7.png";